module.exports = __webpack_public_path__ + "img/blood-pressure-log_B09M4Y382T.cf063918.jpg";